import { render, staticRenderFns } from "./mobile-home.vue?vue&type=template&id=564ec9b5&scoped=true&"
import script from "./mobile-home.vue?vue&type=script&lang=js&"
export * from "./mobile-home.vue?vue&type=script&lang=js&"
import style0 from "./mobile-home.vue?vue&type=style&index=0&id=564ec9b5&prod&lang=scss&scoped=true&"
import style1 from "./mobile-home.vue?vue&type=style&index=1&id=564ec9b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ec9b5",
  null
  
)

export default component.exports